export default "__VITE_ASSET__Dhhk4Ggj__"